import { InitializedReducer } from 'redux-utils';

export function chainReducers<TState extends {}>(
    ...reducers: InitializedReducer<TState, any>[]
): InitializedReducer<TState> {
    return reducers.reduce((result, reducer) => (state, action) => reducer(result(state, action), action));
}
